@if (loadingService.isLoading | async) {
  <div
    class="loading-overlay z-50 flex h-screen flex-col items-center justify-center"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 201.728 189.2"
      class="loading-icon"
    >
      <g
        id="Group_7809"
        data-name="Group 7809"
        transform="translate(-929 -501.999)"
      >
        <path
          id="Path_214"
          data-name="Path 214"
          d="M0,80.093c95.679-18.035,148.156,3.253,160,9.354,37.435,19.266,35.5,43.859,32.256,52.955-1.671,4.663-5,.532-5,.532S154.621,80.319,0,80.093"
          transform="translate(929 526.184)"
          fill="#00aef0"
        />
        <path
          id="Path_215"
          data-name="Path 215"
          d="M144.212,113.915c18.848,11.1,24.036,32.677,20.644,39.959-2.333,4.974-5.206,1.649-5.206,1.649s-36-42.165-133.01-54.842c68.029-6.621,96.7,1.873,117.584,13.232"
          transform="translate(937.831 534.587)"
          fill="#f89520"
        />
        <path
          id="Path_216"
          data-name="Path 216"
          d="M48.147.069s67.85-.157,74.068,0c20.6-1.176,55.255,13.665,53.87,49.883-3.191,30.4-27.337,38.345-27.337,38.345s35.815,7.959,37.044,46.06c-30.07-38.1-92.347-49.119-92.347-49.119s45.821-.3,46.14-30.543c.289-28.657-35.029-25.981-35.029-25.981H82.736V83.058a293.628,293.628,0,0,0-34.525-6.183c-.2-8.25-.065-76.807-.065-76.807"
          transform="translate(944.935 502)"
          fill="#fff"
        />
      </g>
    </svg>
    <p class="mt-4 text-center font-freightSansProBold text-xl text-white">
      Cargando, espere un momento...
    </p>
  </div>
}
